import classNames from "classnames";
import "./style.scss";

const GenericSlideTab = ({ label, isActive, onClick }) => {
  return (
    <div
      className={classNames("slide-tab", {
        active: isActive
      })}
      onClick={onClick}
    >
      <div className="slide-tab-label">
        <div>{label}</div>
      </div>
    </div>
  );
};

export default GenericSlideTab;
